import React from 'react';
import { X } from 'lucide-react';

interface PageLocationsChipProps {
  label: string;
  onRemove: () => void;
}

export const PageLocationsChip: React.FC<PageLocationsChipProps> = ({ label, onRemove }) => {
  return (
    <div className='flex flex-row items-center rounded-full px-2 py-1 w-fit bg-[#D5EEEE]'>
      <p className='text-xs font-semibold truncate text-[#667085]'>{label}</p>
      <X
        className='size-3 cursor-pointer ml-1 flex-shrink-0 text-[#667085]'
        onClick={onRemove}
        aria-label='Remove location'
      />
    </div>
  );
};
